import { render, staticRenderFns } from "./lead-sources-list.vue?vue&type=template&id=15135dd4"
import script from "./lead-sources-list.vue?vue&type=script&lang=js"
export * from "./lead-sources-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports